module.exports = __webpack_public_path__ + "img/kmitl-go.720393bf.png";